import React, { useState, useEffect } from 'react';
import './Notification.css';

const Notification = ({ message, type, onClose, duration = 3000 }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => {
        if (onClose) onClose();
      }, 300); // Wait for fade out animation before calling onClose
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className={`notification ${type} ${visible ? 'visible' : 'hidden'}`}>
      <div className="notification-content">
        <div className="notification-icon">
          {type === 'success' ? (
            <i className="bx bx-check-circle"></i>
          ) : (
            <i className="bx bx-error-circle"></i>
          )}
        </div>
        <div className="notification-message">{message}</div>
        <button className="notification-close" onClick={() => onClose && onClose()}>
          <i className="bx bx-x"></i>
        </button>
      </div>
    </div>
  );
};

export default Notification; 